import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, RadioGroup, FormControlLabel, Button,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import '../TargetSearchComponent';
import {
  CONDITION_RADIO,
  CONTRACT_LABEL,
  EXISTS,
} from '../../../../common/const';
import {
  setAdditionalitem,
  setTradesearchflag1,
  setTradesearchflag2,
  setTradeInfoPopFlg,
  setTradeInfoAddCondition,
} from '../../../actions/TargetAction';
import styles from '../style.module.css';
import config from '../../../../common/config';
import CustomRadio from '../../common/CustomRadio';

class AdditionalInfometionParts extends Component {
  /**
   *取引情報条件ポップアップを画面に表示する。
   */
  showAdditionalItemPop = () => {
    const {
      tradeInfoCondition,
      setTradeInfoPopFlgAct,
      setTradeInfoAddConditionAct,
    } = this.props;

    setTradeInfoAddConditionAct(tradeInfoCondition);
    setTradeInfoPopFlgAct(true);
  };

  render() {
    const {
      setAdditionalitemAct,
      additionalitem,
      contractLabel,
      tradesearchflag1,
      tradesearchflag2,
      setTradesearchflag1Act,
      setTradesearchflag2Act,
      tradeInfoCondition,

    } = this.props;

    const targetInfoCategory = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.TARGET_INFO_CATEGORY,
    );
    const targetInfoChoice1 = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.TARGET_INFO_CHOICE1,
    );
    const targetInfoChoice2 = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.TARGET_INFO_CHOICE2,
    );
    const targetInfoChoice3 = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.TARGET_INFO_CHOICE3,
    );
    const targetButton = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.TARGET_ADDITIONAL_BUTTON,
    );

    const InfomationRadios = [
      {
        exsist: targetInfoChoice1,
        value: CONDITION_RADIO.CONDITION_FALSE,
      },
      {
        exsist: targetInfoChoice2,
        value: CONDITION_RADIO.CONDITION_TRUE,
      },
      {
        exsist: targetInfoChoice3,
        value: CONDITION_RADIO.CONDITION_NONE,
      },
    ];

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>{targetInfoCategory ? targetInfoCategory[0]?.label : ''}</Typography>
          </Box>
          <Box className={`${styles.searchTargetItemInterval}`}>
            <Box>
              <RadioGroup row>
                {InfomationRadios.map((item, i) => (
                  <FormControlLabel
                    key={i}
                    label={item.exsist ? item.exsist[0].label : ''}
                    control={<CustomRadio />}
                    checked={additionalitem === item.value}
                    onChange={() => setAdditionalitemAct(item.value)}
                    className={i === 0 ? '' : `${styles.marginLeft1}`}
                  />
                ))}
              </RadioGroup>

              {((config.TRADE_SEARCH_FLG.FLG1.DISP === EXISTS.FOUND
                || config.TRADE_SEARCH_FLG.FLG2.DISP === EXISTS.FOUND)
                && ((additionalitem === CONDITION_RADIO.CONDITION_TRUE
                  || additionalitem === CONDITION_RADIO.CONDITION_NONE))) && (
                  <Box className={`${styles.additionalitemsearchflg}`}>
                    {config.TRADE_SEARCH_FLG.FLG1.DISP === EXISTS.FOUND && (
                      <Box className={`${styles.marginTopHalf}`}>
                        <Typography component="div" className={`${styles.sectionSubTitle}`}>{config.TRADE_SEARCH_FLG.FLG1.NAME}</Typography>
                        <RadioGroup row>
                          <FormControlLabel
                            control={<CustomRadio />}
                            label={config.TRADE_SEARCH_FLG.FLG1.FALSE}
                            checked={tradesearchflag1 === CONDITION_RADIO.CONDITION_FALSE}
                            onClick={() => setTradesearchflag1Act(CONDITION_RADIO.CONDITION_FALSE)}
                          />
                          <FormControlLabel
                            control={<CustomRadio />}
                            label={config.TRADE_SEARCH_FLG.FLG1.TRUE}
                            checked={tradesearchflag1 === CONDITION_RADIO.CONDITION_TRUE}
                            onClick={() => setTradesearchflag1Act(CONDITION_RADIO.CONDITION_TRUE)}
                          />
                          <FormControlLabel
                            control={<CustomRadio />}
                            label={config.TRADE_SEARCH_FLG.FLG1.NONE}
                            checked={tradesearchflag1 === CONDITION_RADIO.CONDITION_NONE}
                            onClick={() => setTradesearchflag1Act(CONDITION_RADIO.CONDITION_NONE)}
                          />
                        </RadioGroup>
                      </Box>
                    )}
                    {config.TRADE_SEARCH_FLG.FLG2.DISP === EXISTS.FOUND && (
                      <Box className={`${styles.marginTopHalf}`}>
                        <Typography component="div" className={`${styles.sectionSubTitle}`}>{config.TRADE_SEARCH_FLG.FLG2.NAME}</Typography>
                        <RadioGroup row>
                          <FormControlLabel
                            control={<CustomRadio />}
                            label={config.TRADE_SEARCH_FLG.FLG2.FALSE}
                            checked={tradesearchflag2 === CONDITION_RADIO.CONDITION_FALSE}
                            onClick={() => setTradesearchflag2Act(CONDITION_RADIO.CONDITION_FALSE)}
                          />
                          <FormControlLabel
                            control={<CustomRadio />}
                            label={config.TRADE_SEARCH_FLG.FLG2.TRUE}
                            checked={tradesearchflag2 === CONDITION_RADIO.CONDITION_TRUE}
                            onClick={() => setTradesearchflag2Act(CONDITION_RADIO.CONDITION_TRUE)}
                          />
                          <FormControlLabel
                            control={<CustomRadio />}
                            label={config.TRADE_SEARCH_FLG.FLG2.NONE}
                            checked={tradesearchflag2 === CONDITION_RADIO.CONDITION_NONE}
                            onClick={() => setTradesearchflag2Act(CONDITION_RADIO.CONDITION_NONE)}
                          />
                        </RadioGroup>
                      </Box>
                    )}
                  </Box>
              )}
            </Box>
            <Box className={`${styles.displayFlex}`}>
              <Button
                variant="contained"
                className="tertiary"
                endIcon={<OpenInNewIcon />}
                onClick={this.showAdditionalItemPop}
              >
                {targetButton ? targetButton[0]?.label : ''}
              </Button>
              {tradeInfoCondition
                && tradeInfoCondition.length > 0
                && (
                  <Typography className={`${styles.countLabel}`} component="span">{`≫${tradeInfoCondition.length}件の条件を設定中`}</Typography>
                )}
            </Box>
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    additionalitem: state.target.additionalitem,
    contractLabel: state.common.contractLabel,
    tradesearchflag1: state.target.tradesearchflag1,
    tradesearchflag2: state.target.tradesearchflag2,
    tradeInfoCondition: state.target.tradeInfoCondition,
  }),
  (dispatch) => ({
    setAdditionalitemAct: (str) => dispatch(setAdditionalitem(str)),
    setTradesearchflag1Act: (bool) => dispatch(setTradesearchflag1(bool)),
    setTradesearchflag2Act: (bool) => dispatch(setTradesearchflag2(bool)),
    setTradeInfoPopFlgAct: (bool) => dispatch(setTradeInfoPopFlg(bool)),
    setTradeInfoAddConditionAct: (obj) => dispatch(setTradeInfoAddCondition(obj)),
  }),
)(AdditionalInfometionParts);
